import VehiclesGroupedReport from "./VehiclesGroupedReport";

export default function VehiclesByBunk() {
  return (
    <VehiclesGroupedReport
      title="Vehicles by Bunk"
      subtitle="Active fuel access registrations grouped by the bunk (retail outlet) of the creating user."
      dimension="retail_outlet"
      dropdownLabel="Retail Outlet"
      dropdownPlaceholder="All retail outlets"
      dropdownApiPath="/master/retail_outlets"
    />
  );
}
